/**
 * Shared fetch utility for all agent backend requests.
 * Stores the session token in sessionStorage and attaches it
 * as an Authorization: Bearer header on every request.
 */

export const AGENT_URL = import.meta.env.VITE_AGENT_URL || 'http://127.0.0.1:5000';

const TOKEN_KEY = 'agent_session_token';

export function setAgentToken(token: string): void {
  sessionStorage.setItem(TOKEN_KEY, token);
}

export function getAgentToken(): string | null {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function agentFetch(path: string, opts?: RequestInit): Promise<Response> {
  const token = getAgentToken();
  const headers = new Headers(opts?.headers);
  if (token) headers.set('Authorization', `Bearer ${token}`);
  return fetch(`${AGENT_URL}${path}`, { ...opts, headers });
}
